import { Grid } from '@mui/material';
import { useEffect, useState } from 'react';
import { v4 as uuid } from 'uuid';
import Utils from '../../../utils/Utils';
import BlockProps from '../../../models/BlockProps';
import BlockButtonData from './BlockButtonData';
import LinkButton from '../../Buttons/LinkButton';
import BlockData from '../../../models/BlockData';
import BlockComponentButton from '../../../models/BlockComponentValues/BlockComponentButton';
import BlockComponentImage from '../../../models/BlockComponentValues/BlockComponentImage';
import useGetBackground from '../../../hooks/UseGetBackground';
import BackGroundImageModal from '../../Modals/ImageModal/BackGroundImageModal';
import useParallaxScript from '../../../hooks/useParallaxScript';
import config from '../../../config';

export interface BlockButtonProps extends BlockProps {
  blockData: BlockData[]
}

function BlockButton({
  data, isEditing, isTemplate, editHandler, blockData, showImageModal, onCloseImageModal, mainColor,
}: BlockButtonProps) {
  const [props, setProps] = useState<BlockButtonData>(data.data as BlockButtonData);
  const handleUpdate = (button?: BlockComponentButton) => {
    props.button = button;
    editHandler(data.id, props);
  };

  useEffect(() => {
    setProps(data.data as BlockButtonData);
  }, [data.data]);

  const elementUuid = uuid();
  useParallaxScript(props.url?.settings?.parallaxBool, elementUuid, config.backgroundImage.parallaxEffect);

  return (
    <Grid
      id={elementUuid}
      container
      spacing={0}
      direction="column"
      alignItems="center"
      justifyContent="center"
      sx={{
        minHeight: '100px',
        padding: 1.5,
        overflow: 'hidden',
        ...useGetBackground(
          props.url?.solidColor,
          props.url?.value,
          props.url?.settings?.scale,
          props.url?.settings?.scaleBool,
        ),
        backgroundPosition: 'center 0px',
      }}
    >
      {(isEditing && !isTemplate) && (
        <BackGroundImageModal
          backgroundImage={props.url}
          isShowModal={showImageModal}
          onCloseModal={onCloseImageModal}
          handleOnConfirm={(url: BlockComponentImage) => {
            const tempBg = { ...props, url: { ...url } };
            setProps(tempBg);
            editHandler(data.id, tempBg);
          }}
        />
      )}

      <Grid
        container
        spacing={0}
        direction="column"
        alignItems="center"
        justifyContent="center"
        className="block-content-wrapper"
      >
        <Grid
          item
          sx={[Utils.hoverBorder(isEditing), {
            maxWidth: '100%',
            maxHeight: '100%',
            height: '100%',
            width: '100%',
          }]}
        >
          <LinkButton
            mainColor={mainColor}
            button={props.button}
            isEditable={isEditing && !isTemplate}
            isTemplate={isTemplate}
            updateHandler={handleUpdate}
            blockData={blockData}
          />
        </Grid>
      </Grid>
    </Grid>
  );
}

export default BlockButton;
